import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        const raw = localStorage.getItem("awc_user");
        return raw ? JSON.parse(raw) : null;
    });

    const login = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("awc_token", res.data.token);
        localStorage.setItem("awc_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };
    const logout = () => {
        localStorage.removeItem("awc_token");
        localStorage.removeItem("awc_user");
        setUser(null);
    };
    return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
